import React, { useRef, useState, useContext, useEffect } from 'react';

import styles from './SubMenu.module.css';
import imgBtnAprobar from '../../img/btnaprobar.png'

//Context
import GeneralContext from '../../context/GeneralContext';
import * as GLOBALES from '../../utils/globales'

const SubMenu = ({ history, modal, desplaza, validarPantalla }) => {
    const initialState = {
        listaMenu: []
    }
    const [showMenu, setShowMenu] = useState(false)
    const [localState, setLocalState] = useState(initialState)
    const { state } = useContext(GeneralContext)
    const menuDescripcionRef = useRef()
    const tableRef = useRef()

    let user = state.users.filter(user => user.isAuthenticated)[0]
    let prospecto = user.listaProspectos.filter(prospecto => prospecto.isSelected)[0]

    useEffect(() => {
        let listaMenu = null
        if (prospecto.cotizaciones !== null && prospecto.cotizaciones !== undefined) {
            prospecto.cotizaciones.map(cotizacion => {
                if (cotizacion.isSelected) {
                    listaMenu = cotizacion.listaMenu
                }
                return cotizacion
            })
        }

        listaMenu = listaMenu !== null ? listaMenu : GLOBALES.LISTA_MENU_INICIAL

        setLocalState((localState) => {
            return {
                listaMenu: listaMenu
            }
        })
    }, [])

    let listaMenu = null
    localState.listaMenu.map(menu => {
        if (menu.listaSubmenu !== undefined && menu.listaSubmenu !== null && menu.listaSubmenu.length > 0) {
            menu.listaSubmenu.map(submenu => {
                if (submenu.url === history.location.pathname) {
                    listaMenu = menu.listaSubmenu
                }
                return submenu
            })
        }

        return menu
    })

    const getLineaSalida = (menu, index, menuProximo) => {
        let salida = null
        let lineaEspecial = listaMenu.length === 6

        if (listaMenu.length === index + 1) {
            salida = <div className={styles['lineacolorsin']}></div>
        } else {
            if ((menuProximo !== undefined && menuProximo.url === history.location.pathname && menu.completado) ||
                (menu.completado && menuProximo !== undefined && menuProximo.completado)) {
                salida = <div className={listaMenu.length === 6 ? `${styles['lineacolorazul']} 
                        ${lineaEspecial ? styles['lineacolorespecial'] : null}` : `${styles['lineacolorazul7']} 
                        ${lineaEspecial ? styles['lineacolorespecial'] : null}`}></div>
            } else {
                salida = <div className={listaMenu.length === 6 ? `${styles['lineacolorgris']} 
                    ${lineaEspecial ? styles['lineacolorespecial'] : null}` :
                    `${styles['lineacolorgris7']} 
                    ${lineaEspecial ? styles['lineacolorespecial'] : null}`}></div>
            }
        }

        return salida
    }

    const redireccionar = async (menu) => {
        if(validarPantalla !== undefined && validarPantalla !== null) {
            let validado = await validarPantalla()
            if(validado) {
                history.push(menu.url)
            }
        } else {
            history.push(menu.url)
        }
    }

    const getCentroCirculo = (menu, index) => {
        let salida = null
        let url = null

        if (menu.completado && menu.url !== history.location.pathname) {
            salida = (
                <div className={styles['circuloazul']} onClick={(menu) => redireccionar(menu)}>
                    <img src={imgBtnAprobar} alt='' />
                </div>
            )
        } else {
            if (menu.url === history.location.pathname) {
                salida = <a className={styles['circuloazul']} href={url}><span>{index + 1}</span></a>
            } else {
                salida = <a className={styles['circulogris']} href={url}>{index + 1}</a>
            }
        }

        return salida
    }

    const handlePointClick = () => {
        setShowMenu(!showMenu)
        desplaza(!showMenu)
    }

    return (
        listaMenu !== undefined && listaMenu !== null
            ? <div className={modal ? styles['subModal'] : styles['flotante']}>
                <table ref={tableRef} onClick={handlePointClick}
                    className={styles['subnavegacion']}
                    cellSpacing='0'
                    cellPadding='0'>
                    <tbody>
                        {listaMenu.map((menu, index) => (
                            <tr key={menu.id}>
                                <th>
                                    <div className={styles['areasubnavegacion']}>
                                        <div className={styles[menu.url === history.location.pathname
                                            ? 'lineacolorcirculo'
                                            : 'lineacolorcirculosin']}>
                                            {getCentroCirculo(menu, index)}
                                        </div>
                                        {getLineaSalida(menu, index, listaMenu[index + 1])}
                                    </div>
                                </th>
                            </tr>
                        ))}
                    </tbody>
                </table>
                <div style={tableRef.current !== undefined ? { height: tableRef.current.clientHeight } : null} ref={menuDescripcionRef}
                    className={`${listaMenu.length === 6
                        ? `${styles['th-flotante']} ${styles['th-flotante-esp']}`
                        : styles['th-flotante']} 
                        ${styles[showMenu ? 'th-flotante-fun' : 'th-flotante']}`}>
                    <div className={styles['label-contenedor']}>
                        {listaMenu.map((menu2, index2) => (
                            <div key={menu2.id}
                                className={`${styles['labelsubnavegacion']}
                                    ${index2 === 0
                                        ? listaMenu.length === 6
                                            ? `${styles['label-first-esp']}`
                                            : styles['label-first']
                                        : ''}
                                    ${listaMenu.length === 6
                                        ? `${styles['label-noactual-esp']}`
                                        : styles['label-noactual']}`/*menu2.paginaActual
                                        ? listaMenu.length === 6
                                            ? `${styles['label-actual-esp']}`
                                            : `${styles['label-actual']}`
                                        : listaMenu.length === 6
                                            ? `${styles['label-noactual-esp']}`
                                            : styles['label-noactual']}`*/}>
                                {
                                    menu2.completado
                                        ? <div onClick={(menu2) => redireccionar(menu2)} style={{cursor: 'pointer'}}>{menu2.descripcion}</div>
                                        : menu2.descripcion
                                }
                            </div>
                        ))}
                    </div>
                </div>
            </div>
            : ''
    )
}

export default SubMenu;
